/**
 * Helpers for Category page deep-link URL query parameters.
 * Supports ?collection=<contractAddress>&item=<listingId>
 */

const PARAM_COUNTRY = "country";
const PARAM_COLLECTION = "collection";
const PARAM_ITEM = "item";

/**
 * Parse location.search into { country, collection, item }.
 * Collection is normalized to lowercase.
 * @param {string} search - e.g. "?country=Egypt&collection=0x123&item=19"
 * @returns {{ country: string | null, collection: string | null, item: string | null }}
 */
export function parseSearch(search) {
  if (!search || typeof search !== "string") {
    return { country: null, collection: null, item: null };
  }
  const params = new URLSearchParams(
    search.startsWith("?") ? search : `?${search}`
  );
  const country = params.get(PARAM_COUNTRY);
  const collection = params.get(PARAM_COLLECTION);
  const item = params.get(PARAM_ITEM);
  return {
    country: country ? country.trim() : null,
    collection: collection ? collection.trim().toLowerCase() : null,
    item: item ? item.trim() : null,
  };
}

/**
 * Build search string from country, collection and optional item.
 * Falsy values are omitted.
 * @param {{ country?: string | null, collection?: string | null, item?: string | null }} params
 * @returns {string} - e.g. "?country=Egypt&collection=0x123&item=19" or ""
 */
export function buildSearch({ country, collection, item }) {
  const params = new URLSearchParams();
  if (country) params.set(PARAM_COUNTRY, country);
  if (collection) params.set(PARAM_COLLECTION, collection.toLowerCase());
  if (item) params.set(PARAM_ITEM, String(item));
  const str = params.toString();
  return str ? `?${str}` : "";
}

/**
 * Normalize collection address for comparison (lowercase).
 * @param {string} address
 * @returns {string}
 */
export function normalizeCollectionAddress(address) {
  return address ? String(address).trim().toLowerCase() : "";
}
